import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import InputMuiCustom from '../../../components/common/inputs/InputMuiCustom';
import moment from 'moment';
import DatePickerMui from '../../../components/common/DatePickerMui';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
import axios from 'axios';

interface IArray {
  [key: string]: any;
}

const CreateHeader = ({
  customer_name,
  partName,
  partNumber,
  msaData,
  process,
  spec,
  setSpec,
  autoCompleteProcess,
  setAutoCompleteProcess,
  setAutoCompleteSpec,
  autoCompleteSpec,
  setInstrumentType,
  instrumentType,
  uslVal,
  lslVal,
}: any) => {
  const [render, setRender] = useState<Boolean>(false);
  const [instrumentData, setInstrumentData] = useState<any>([]);
  const [instrumentId, setInstrumentId] = useState<any>(null);

  console.log('msaData', msaData);

  useEffect(() => {
    axios
      .get(`/api/gaugeRoute/masterlistinstrument`)
      .then((res) => {
        console.log('res', res);
        const temp0 = res?.data;

        const transformedData = temp0.map((instrument: any) => ({
          label: `${instrument.make}-${instrument.id_no}`,
          value: `${instrument.make}-${instrument.id_no}`,
          instrument_id: instrument._id,
          instrument_type: instrument.instrument_type,
          option_name: `${instrument.make}-${instrument.id_no}`,
        }));

        setInstrumentData(transformedData);
      })
      .catch((err) => console.log(err));
  }, []);

  console.log('instrumentData,', instrumentData);

  return (
    <>
      <Box sx={{ flexGrow: 1, width: '98%', margin: '2rem auto' }}>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <InputMuiCustom
              type="string"
              name="part_name"
              variant={'outlined'}
              placeholder={'Part Name'}
              value={partName || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <InputMuiCustom
              type="string"
              name="part_no"
              variant={'outlined'}
              placeholder={'Part No.'}
              value={partNumber || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>

          <Grid item xs={2}>
            <AutocompleteMuiCustom
              id="category_id.name"
              label="Instrument List"
              option_name="option_name"
              arrayofObj={instrumentData}
              value={instrumentData.value ?? ''}
              onChange={(e, value) => {
                console.log('val', value);
                msaData.instrument_id = value?.instrument_id; // Set instrument_id
                msaData.instrument_type = value?.instrument_type;
                setInstrumentType(value);
                setRender((prev) => !prev);
              }}
            />
          </Grid>

          <Grid item xs={2}>
            <AutocompleteMuiCustom
              id={'process_name'}
              label="OPERATION/PROCESS NAME"
              option_name={'process_name'}
              value={autoCompleteProcess}
              arrayofObj={process}
              onChange={(e, value) => {
                value?.process_name
                  ? (msaData.process_id = value._id)
                  : (msaData.process_id = '');
                setAutoCompleteProcess(value);
                value?.specs ? setSpec(value.specs) : setSpec([]);
                setAutoCompleteSpec('');
                setRender((prev) => !prev);
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 0.2 }}>
          <Grid item xs={2}>
            <InputMuiCustom
              type="string"
              name="parameters"
              variant={'outlined'}
              placeholder={'Parameters'}
              value={`${uslVal || ''} +- ${lslVal || ''}` || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <InputMuiCustom
              type="string"
              name="usl"
              variant={'outlined'}
              placeholder={'USL'}
              value={uslVal || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <InputMuiCustom
              type="string"
              name="lsl"
              variant={'outlined'}
              placeholder={'lSL'}
              value={lslVal || ''}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 0.2 }}>
          <Grid item xs={2}>
            <InputMuiCustom
              variant={'outlined'}
              type="text"
              name="appraisers_A"
              placeholder={'Appraisers A'}
              onChange={(e) => {
                msaData[e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
              value={msaData.appraisers_A}
            />
          </Grid>
          <Grid item xs={2}>
            <InputMuiCustom
              variant={'outlined'}
              type="text"
              name="appraisers_B"
              placeholder={'Appraisers B'}
              onChange={(e) => {
                msaData[e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
              value={msaData.appraisers_B}
            />
          </Grid>
          <Grid item xs={2}>
            <InputMuiCustom
              variant={'outlined'}
              type="text"
              name="appraisers_C"
              placeholder={'Appraisers C'}
              onChange={(e) => {
                msaData[e.target.name] = e.target.value;
                setRender((prev) => !prev);
              }}
              value={msaData.appraisers_C}
            />
          </Grid>
          <Grid item xs={2}>
            <DatePickerMui
              label="Date"
              value={moment(msaData.date || null)}
              onChange={(date) => {
                msaData.date = date;
                setRender((prev) => !prev);
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default CreateHeader;
